module.exports = __webpack_public_path__ + "static/img/8.5a300a5.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/7/8.png
// module id = 286
// module chunks = 0